import React, { useState, useEffect,useRef,FC } from "react";
import { useHistory } from "react-router";
import { useNavModel } from "../../../../model/navModel";
import { useDataCatalogModel } from "../dataCatalogModel";
import { Form, Button, Table } from "antd";
import { AppDrawer } from "../../../../components2/YhDrawer";
import { YhForm } from "../../../../components2/YhFormBox";
import { DetailType } from "../dataCatalogTypes";
import {FormItemTypeEnum, IYhForm, IYhFormRef} from "../../../../components2/YhFormBox/Types";
import {FieldDetails } from "../dataCatalogService"



const DetailDrawer = () => {
    const formRef = useRef<IYhFormRef>()
    const { drawerVisible: visible,drawerTitle,fieldSelectRow,fieldAdd, setDrawerVisible,changeField,addChangeField,insertField,editField } = useDataCatalogModel();
    const onCancel = () => {
        setDrawerVisible(false);
    }

    const onFinish = (value:any)=>{
    }
    const onChange = (value:FieldDetails)=>{
        if(drawerTitle==DetailType.add){
            addChangeField(value)
        }else if(drawerTitle==DetailType.edit){
            changeField(value)
        }
    }
    const save = ()=>{
        if(drawerTitle==DetailType.add){
            insertField()
        }else if(drawerTitle==DetailType.edit){
            editField()
        }
    }
    const formConfig: IYhForm = {
        formRef: formRef,
        labelCol: { span: 6 },
        disabled: false,
        onFinish:onFinish,
        onChange:onChange,
        formValues:drawerTitle == DetailType.add ?fieldAdd:fieldSelectRow,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "字段编码",
                fieldName: "code",
                span: 24,
                disable:drawerTitle==DetailType.edit,
                rules: [{ required: true, message: '该项为必填项' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "数据类型",
                fieldName: "dataType",
                span: 24,
            }, {
                type: FormItemTypeEnum.InputNumber,
                fieldLabel: "最大长度",
                fieldName: "maxLength",
                span: 24,
                max:1000,
                min:0
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "可更新",
                fieldName: "updatable",
                span: 24,
                options:[{key:1,label:"更新",value:1},{key:0,label:"不更新",value:0}]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "是否可为空",
                fieldName: "nullable",
                span: 24,
                options:[{key:1,label:"是",value:1},{key:0,label:"否",value:0}]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "唯一",
                fieldName: "repeatable",
                span: 24,
                options:[{key:1,label:"全表唯一",value:1},{key:2,label:"分支唯一",value:2},{key:0,label:"否",value:0}]
            }
        ]
    };

    return <AppDrawer
        {...{
            title: `${drawerTitle==DetailType.add?'新增':'编辑'}字段`,
            visible,
            onCancel,
            showFooter: true,
            okText:'保存',
            onOk:save
        }}
        
    > 
        <YhForm {...formConfig} />
    </AppDrawer>
}

export default DetailDrawer